import { Label } from "@/components/ui/label";
import { FinalChipsRow } from "@/components/FinalChipsRow";
import { HiddenPlayersPanel } from "@/components/HiddenPlayersPanel";
import type { PlayerDraft, HiddenFinalPlayer } from "@/hooks/usePlayersState";

interface FinalChipsSectionProps {
  visibleFinalPlayers: PlayerDraft[];
  hiddenFinalPlayers: HiddenFinalPlayer[];
  players: PlayerDraft[];
  chipInputValue: (playerId: string, field: "chipsBought" | "finalChips", storedRawValue: string) => string;
  beginChipEdit: (playerId: string, field: "chipsBought" | "finalChips", currentRawValue: string) => void;
  changeChipEdit: (playerId: string, field: "chipsBought" | "finalChips", nextValue: string) => void;
  endChipEdit: (playerId: string, field: "chipsBought" | "finalChips") => void;
  hidePlayerFromFinalList: (id: string) => void;
  restorePlayerToFinalList: (id: string) => void;
}

export function FinalChipsSection({
  visibleFinalPlayers,
  hiddenFinalPlayers,
  players,
  chipInputValue,
  beginChipEdit,
  changeChipEdit,
  endChipEdit,
  hidePlayerFromFinalList,
  restorePlayerToFinalList,
}: FinalChipsSectionProps) {
  return (
    <div className="rounded-lg border p-3 md:p-4 space-y-3">
      <h2 className="font-semibold">2. Final chips per player</h2>
      <div className="grid grid-cols-[1.75rem_minmax(0,1fr)_4.75rem] gap-2 md:grid-cols-[1.75rem_2fr_1fr] md:gap-3">
        <span />
        <Label>Player</Label>
        <Label>Final chips</Label>
      </div>

      <div className="space-y-3">
        {visibleFinalPlayers.map((player, index) => (
          <FinalChipsRow
            key={`final-${player.id}`}
            player={player}
            rowLabel={index + 1}
            chipInputValue={chipInputValue}
            beginChipEdit={beginChipEdit}
            changeChipEdit={changeChipEdit}
            endChipEdit={endChipEdit}
            hidePlayerFromFinalList={hidePlayerFromFinalList}
          />
        ))}
      </div>

      <HiddenPlayersPanel
        hiddenFinalPlayers={hiddenFinalPlayers}
        players={players}
        restorePlayerToFinalList={restorePlayerToFinalList}
      />
    </div>
  );
}
